<!-- display 30 length of string -->
<p>{{ display_text }}</p>
